/* FÉNIX 2.1 — R07 v09 · Noopept cinematic interaction engine. */
(function(){'use strict';
  function ready(fn){if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',fn,{once:true});else fn();}
  ready(function(){
    var root=document.querySelector('[data-fnxr07-noopept]');
    if(!root)return;
    document.body.classList.add('fnxr07-noopept-v06','fnxr07-noopept-v09');
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var fine=window.matchMedia&&window.matchMedia('(hover:hover) and (pointer:fine)').matches;

    /* PRODUCT-SPECIFIC MOLECULE ENGINE. It renders only when verified structure data exists. */
    var visual=root.querySelector('[data-fnxr07-science-visual]');
    var moleculeSrc=root.getAttribute('data-fnx-molecule-src');
    if(visual&&moleculeSrc&&!visual.querySelector('.fnxr07-molecule-v09')){
      var mol=document.createElement('div');
      mol.className='fnxr07-molecule-v09';
      mol.setAttribute('aria-hidden','true');
      var name=root.getAttribute('data-fnx-molecule-name')||'';
      var formula=root.getAttribute('data-fnx-molecule-formula')||'';
      var mass=root.getAttribute('data-fnx-molecule-mass')||'';
      var cid=root.getAttribute('data-fnx-molecule-cid')||'';
      mol.innerHTML='<div class="fnxr07-molecule-v09__beam"></div><div class="fnxr07-molecule-v09__orbit fnxr07-molecule-v09__orbit--a"></div><div class="fnxr07-molecule-v09__orbit fnxr07-molecule-v09__orbit--b"></div><div class="fnxr07-molecule-v09__orbit fnxr07-molecule-v09__orbit--c"></div><div class="fnxr07-molecule-v09__stage"><img class="fnxr07-molecule-v09__layer fnxr07-molecule-v09__layer--back" src="'+moleculeSrc+'" alt=""><img class="fnxr07-molecule-v09__layer fnxr07-molecule-v09__layer--main" src="'+moleculeSrc+'" alt=""><img class="fnxr07-molecule-v09__layer fnxr07-molecule-v09__layer--front" src="'+moleculeSrc+'" alt=""></div><div class="fnxr07-molecule-v09__platform"></div><div class="fnxr07-molecule-v09__hud"><strong>'+name+'</strong><span>'+formula+' · '+mass+'<br>PubChem · '+cid+'</span><span class="fnxr07-molecule-v09__topic">Molécula adaptativa</span></div><div class="fnxr07-molecule-v09__hint"><i>↖</i><span>Mueve el cursor<br>para explorar</span></div>';
      for(var p=0;p<20;p++){
        var dot=document.createElement('i');
        dot.className='fnxr07-molecule-v09__particle';
        dot.style.setProperty('--px',(8+Math.random()*84).toFixed(1)+'%');
        dot.style.setProperty('--py',(10+Math.random()*70).toFixed(1)+'%');
        dot.style.setProperty('--ps',(1+Math.random()*2.2).toFixed(1)+'px');
        dot.style.setProperty('--po',(0.18+Math.random()*0.55).toFixed(2));
        dot.style.setProperty('--dur',(3.8+Math.random()*5.5).toFixed(1)+'s');
        dot.style.setProperty('--delay',(-Math.random()*5).toFixed(1)+'s');
        dot.style.setProperty('--depth',(8+Math.random()*35).toFixed(1));
        mol.appendChild(dot);
      }
      visual.appendChild(mol);
      if(fine&&!reduce){
        var raf=0;
        mol.addEventListener('pointermove',function(e){
          if(raf)cancelAnimationFrame(raf);
          raf=requestAnimationFrame(function(){
            var r=mol.getBoundingClientRect();
            var nx=Math.max(-.5,Math.min(.5,(e.clientX-r.left)/Math.max(1,r.width)-.5));
            var ny=Math.max(-.5,Math.min(.5,(e.clientY-r.top)/Math.max(1,r.height)-.5));
            mol.style.setProperty('--rx',(-ny*8).toFixed(2)+'deg');
            mol.style.setProperty('--ry',(nx*11).toFixed(2)+'deg');
            mol.style.setProperty('--tx',(nx*9).toFixed(1)+'px');
            mol.style.setProperty('--ty',(ny*7).toFixed(1)+'px');
            mol.style.setProperty('--mx',((nx+.5)*100).toFixed(1)+'%');
            mol.style.setProperty('--my',((ny+.5)*100).toFixed(1)+'%');
            var dots=mol.querySelectorAll('.fnxr07-molecule-v09__particle');
            for(var i=0;i<dots.length;i++){var d=dots[i],depth=parseFloat(d.style.getPropertyValue('--depth'))||10;d.style.setProperty('--dx',(nx*depth*.22).toFixed(1)+'px');d.style.setProperty('--dy',(ny*depth*.18).toFixed(1)+'px');}
          });
          mol.classList.add('is-interacting');
        },{passive:true});
        mol.addEventListener('pointerleave',function(){mol.classList.remove('is-interacting');mol.style.setProperty('--rx','0deg');mol.style.setProperty('--ry','0deg');mol.style.setProperty('--tx','0px');mol.style.setProperty('--ty','0px');mol.style.setProperty('--mx','50%');mol.style.setProperty('--my','48%');},{passive:true});
      }
      var topicLabel=mol.querySelector('.fnxr07-molecule-v09__topic');
      root.querySelectorAll('[data-science-key]').forEach(function(item){
        function activate(){if(topicLabel){var h=item.querySelector('h3');topicLabel.textContent=h?h.textContent:'Molécula adaptativa';}mol.setAttribute('data-active-topic',item.getAttribute('data-science-key')||'');}
        item.addEventListener('mouseenter',activate);item.addEventListener('focusin',activate);
        item.addEventListener('mouseleave',function(){if(topicLabel)topicLabel.textContent='Molécula adaptativa';mol.removeAttribute('data-active-topic');});
        item.addEventListener('focusout',function(){if(topicLabel)topicLabel.textContent='Molécula adaptativa';mol.removeAttribute('data-active-topic');});
      });
    }

    /* CTA inside PROFUNDIZA uses the native product form. */
    var closeCart=root.querySelector('[data-fnxr07-close-cart]');
    var nativeCart=document.getElementById('AddToCart');
    if(closeCart&&nativeCart&&!closeCart.dataset.boundV09){
      closeCart.dataset.boundV09='1';
      function sync(){closeCart.disabled=!!nativeCart.disabled;closeCart.textContent=nativeCart.disabled?'Agotado':'Agregar al carrito';}
      sync();
      closeCart.addEventListener('click',function(){if(!closeCart.disabled)nativeCart.click();});
      new MutationObserver(sync).observe(nativeCart,{attributes:true,attributeFilter:['disabled','class','value']});
    }

    /* Related products: whichever product is selected becomes the large protagonist. */
    var related=document.querySelector('[data-r07-related-dynamic]');
    if(related){
      var cards=Array.prototype.slice.call(related.querySelectorAll('[data-r07-related-card]'));
      cards.forEach(function(card){
        var btn=card.querySelector('[data-r07-related-select]');
        if(!btn)return;
        btn.addEventListener('click',function(){
          if(card.classList.contains('is-featured'))return;
          var first=new Map();cards.forEach(function(c){first.set(c,c.getBoundingClientRect());});
          cards.forEach(function(c){c.classList.remove('is-featured','is-selected');var b=c.querySelector('[data-r07-related-select]');if(b)b.setAttribute('aria-pressed','false');var small=c.querySelector('.r07-related-dynamic__copy small');if(small)small.textContent=small.textContent.replace(/^SELECCIONADO · /,'');});
          card.classList.add('is-featured','is-selected');btn.setAttribute('aria-pressed','true');
          var label=card.querySelector('.r07-related-dynamic__copy small');if(label&&label.textContent.indexOf('SELECCIONADO · ')!==0)label.textContent='SELECCIONADO · '+label.textContent;
          if(!reduce&&Element.prototype.animate){requestAnimationFrame(function(){cards.forEach(function(c){var a=first.get(c),b=c.getBoundingClientRect();var dx=a.left-b.left,dy=a.top-b.top,sx=a.width/Math.max(1,b.width),sy=a.height/Math.max(1,b.height);c.animate([{transform:'translate('+dx+'px,'+dy+'px) scale('+sx+','+sy+')'},{transform:'translate(0,0) scale(1)'}],{duration:520,easing:'cubic-bezier(.16,1,.3,1)'});});});}
        });
      });
    }
  });
})();
